import { useCallback } from "react";
import { useMutation } from "react-query";

import { MUTATION_KEYS } from "../../../constants/queryKeys";
import { CasProfileApi } from "../../../services";

import type { UseSendEmailOTCReturnType } from "./types";

export const useSendEmailOTC = (): UseSendEmailOTCReturnType => {
  const callSendEmailOTC = useMutation(MUTATION_KEYS.sendEmailOTC, (email: string) =>
    CasProfileApi.init().sendEmailOTC(email)
  );

  const sendEmailOTC = useCallback(
    async (email: string) => await callSendEmailOTC.mutateAsync(email),
    [callSendEmailOTC]
  );

  return { sendEmailOTC };
};
